import { Component, inject, input, model } from '@angular/core'
import { MatButtonAppearance } from '@angular/material/button'
import { Router } from '@angular/router'


// These map to directives, e.g. btn-small, etc
export enum ButtonThemeSize {
  Chip = 'chip',
  XSmall = 'xsmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xlarge',
  ResponsiveSmall = 'responsive-small',
  ResponsiveMedium = 'responsive-medium',
  ResponsiveLarge = 'responsive-large',
  ResponsiveXLarge = 'responsive-xlarge',
}


@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false,
})
export class ButtonComponent {
  private _router = inject(Router)
  readonly ButtonThemeSize = ButtonThemeSize
  appearance = model<MatButtonAppearance | ''>('text')
  themeSize = model(ButtonThemeSize.Medium)
  styleOverrides = input({})
  href = input<string>()
  routerLink = input<string | string[]>()
  disabled = input(false)
  ariaLabel = input<string | undefined>()
  multiRow = input(false)
  target = input('_self')
  forceAnchor = input(false)

  onClick() {
    const href = this.href()
    if (this.routerLink()) {
      this._router.navigate([this.routerLink()])
    } else if (href && this.target() === '_self') {
      window.location.href = href
    }
  }
}
